export const TEAL = "#45818e";
export const BLACK = "#000000";
export const PURPLE = "#673AB7";
